/**
 * "Beat the Monkey" mascot pop (specs/home-page AC-10b, §7 motion), taken from the design's `zpMonkeyPop`
 * keyframes: a 7-second cycle, ease-in-out between stops, transform-origin at the feet (bottom-centre).
 * The mascot winds up with a squash, leaps stretched, holds a beat at the apex, lands with a squash,
 * recovers, then rests for the remaining six seconds. One driver moves all three channels together.
 */

export const MONKEY_POP_CYCLE_MS = 7000;

export interface MonkeyPopKeyframe {
  /** Offset within the cycle, 0..1, exactly as the design's percentage stops. */
  at: number;
  translateY: number;
  scaleX: number;
  scaleY: number;
}

export const MONKEY_POP_KEYFRAMES: readonly MonkeyPopKeyframe[] = [
  { at: 0.6, translateY: 0, scaleX: 1, scaleY: 1 }, // rest ends
  { at: 0.63, translateY: 2, scaleX: 1.06, scaleY: 0.92 }, // wind-up squash
  { at: 0.655, translateY: -14, scaleX: 0.96, scaleY: 1.06 }, // stretched leap
  { at: 0.665, translateY: -15, scaleX: 1, scaleY: 1 }, // apex
  { at: 0.69, translateY: 0, scaleX: 1, scaleY: 1 }, // touchdown
  { at: 0.705, translateY: 1, scaleX: 1.05, scaleY: 0.94 }, // landing squash
  { at: 0.73, translateY: 0, scaleX: 1, scaleY: 1 }, // recovered
];

/** Milliseconds of each hop segment (stop i-1 → stop i), from the keyframe offsets. */
export const MONKEY_POP_SEGMENT_MS: readonly number[] = MONKEY_POP_KEYFRAMES.slice(1).map(
  (frame, i) => Math.round((frame.at - MONKEY_POP_KEYFRAMES[i].at) * MONKEY_POP_CYCLE_MS),
);

/** The rest between pops: the cycle minus the hop (the design's 73% → 100% plus 0% → 60%). */
export const MONKEY_POP_REST_MS =
  MONKEY_POP_CYCLE_MS - MONKEY_POP_SEGMENT_MS.reduce((sum, ms) => sum + ms, 0);
